<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="scheduleData"
      style="width: 100.1%;"
    ></Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <Modal v-model="scheduleDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ scheduleName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeSchedule()"
          :disabled="isDisable"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑账户模式框 -->
    <div v-if="showSchedulesModal">
      <edit-schedules
        @on-close-cancel="onCloseCancel"
        :schedulesEditOldForm="schedulesEditForm"
      ></edit-schedules>
    </div>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import utils from "../../../../utils/utils.js";
import EditSchedules from "../schedules/EditSchedules.vue";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

var tableSchedulesVue = {};
export default {
  name: "TableSchedules",
  components: {
    EditSchedules,
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      isShowOperationLog: false,
      schedulesEditForm: {},
      val: "",
      frequencyUnit: [
        this.$t("configuration_management.schedules.minute"),
        this.$t("configuration_management.schedules.hour"),
        this.$t("configuration_management.schedules.day"),
        this.$t("configuration_management.schedules.week"),
        this.$t("configuration_management.schedules.month")
      ],
      enableWeekdays: [
        this.$t("configuration_management.schedules.Sunday"),
        this.$t("configuration_management.schedules.Monday"),
        this.$t("configuration_management.schedules.Tuesday"),
        this.$t("configuration_management.schedules.Wednesday"),
        this.$t("configuration_management.schedules.Thursday"),
        this.$t("configuration_management.schedules.Friday"),
        this.$t("configuration_management.schedules.Saturday")
      ],
      showList: [],
      dataTotal: 0,
      showSchedulesModal: false,
      lineIndex: 0,
      scheduleName: "",
      isDisable: false,
      current: 1,
      pageSize: 10,
      scheduleDelmodal: false,
      modal_loading: false,
      columns: [
        {
          title: this.$t("configuration_management.schedules.name"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.showSchedulesModal = true;
                    this.schedulesEditForm = params.row;
                    this.$emit("on-open-modal");
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t("configuration_management.schedules.frequency"),
          key: "frequency"
        },
        {
          title: this.$t("configuration_management.schedules.enableWeekdays"),
          key: "enableWeekdaysText"
        },
        {
          title: this.$t("configuration_management.schedules.start"),
          key: "scheduleStartTime"
        },
        {
          title: this.$t("configuration_management.schedules.end"),
          key: "scheduleEndTime"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.rowClick(params.row);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: "configurationManagement:schedules:log"
                    }
                  ]
                },
                this.$t("common.operationLog")
              ),
              h("span", {}, " "),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: params.row.flag === false
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.scheduleDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:schedules:delete"
                      )
                    }
                  ]
                },
                this.$t("common.del")
              )
            ]);
          }
        }
      ],
      scheduleData: [
        {
          name: ""
        }
      ]
    };
  },
  beforeCreate: function() {
    tableSchedulesVue = this;
  },
  mounted: function() {
    tableSchedulesVue.getSchedulesData();
  },
  methods: {
    showAll: function() {
      tableSchedulesVue.getSchedulesData();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.scheduleName = this.scheduleData[index].name;
    },
    getSchedulesData: function() {
      // 获取SchedulesSearch里面的搜索内容
      eventBus.$on("scheduleSearchName", function(val) {
        tableSchedulesVue.val = val;
      });
      //日程列表分页
      tableSchedulesVue.$api.scheduleManagement
        .pageScheduleManagement({
          scheduleName: tableSchedulesVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.scheduleData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
          tableSchedulesVue.showSchedule();
        });
    },
    showSchedule: function() {
      for (var i = 0; i < this.scheduleData.length; i++) {
        // 调度
        this.scheduleData[i].frequency =
          this.scheduleData[i].frequencyNum +
          this.frequencyUnit[this.scheduleData[i].frequencyUnit];
        // 周天
        // 保留原始 enableWeekdays 原值(下标字符串)供编辑回填使用,
        // 仅派生一个只读的本地化显示字段 enableWeekdaysText 供表格渲染。
        var arr = utils.methods.strToArr(this.scheduleData[i].enableWeekdays);
        var weekdaysText = "";
        for (var j = 0; j < arr.length; j++) {
          if (j != 0) {
            weekdaysText += "、";
          }
          weekdaysText += this.enableWeekdays[arr[j]];
        }
        this.scheduleData[i].enableWeekdaysText = weekdaysText;
        // 开始日期
        this.scheduleData[i].scheduleStartTime = utils.methods.formatDate(
          this.scheduleData[i].scheduleStartTime
        );
        // 结束日期
        this.scheduleData[i].scheduleEndTime = utils.methods.formatDate(
          this.scheduleData[i].scheduleEndTime
        );
      }
    },
    changePage: function(current) {
      this.current = current;
      tableSchedulesVue.getSchedulesData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSchedulesVue.getSchedulesData();
    },
    // 删除
    removeSchedule: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //日程删除
      this.$api.scheduleManagement
        .deleteSchedule("id", this.scheduleData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableSchedulesVue.getSchedulesData();
            this.isDisable = false;
            this.modal_loading = false;
            this.scheduleDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 销毁scheduleSearchName
    beforeDestroy: function() {
      eventBus.$off("scheduleSearchName");
    },
    onCloseCancel(bool) {
      this.showSchedulesModal = bool;
    },
    // 操作日志
    rowClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          3
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/schedules/TableSchedules.vue